import {Component} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthenticationService, RoutingService, AppToastrService} from '../../services';
import {STATE_NAMES, EMAIL_PATTERN} from '../../common';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordPageComponent {
  form: FormGroup;
  emailCtrl: FormControl;
  isSubmitting: boolean;
  errorMessage: string;

  constructor(private fb: FormBuilder,
              private routingService: RoutingService,
             private toastr: AppToastrService,
              private authenticationService: AuthenticationService) {
    this.emailCtrl = fb.control('', [Validators.required, Validators.pattern(EMAIL_PATTERN)]);
    this.form = fb.group({
      email: this.emailCtrl
    });
  }

  onSubmit() {
    try {
      this.errorMessage = null;
      if (this.form.valid && !this.isSubmitting) {
        this.isSubmitting = true;
        this.authenticationService.forgotPassword(this.emailCtrl.value.toLowerCase()).subscribe((res) => {
          if (res) {
            this.isSubmitting = false;
            this.toastr.showToast({title: 'На Вашу почту было отправлено письмо с информацией о восстановлении пароля.'});
            this.routingService.go(STATE_NAMES.login);
          }
        }, (err) => {
          const defaultMessage = 'Что-то пошло не так. Пожалуйста, попробуйте еще раз или обратитесь к системному администратору.';
          this.errorMessage = err && err.error && err.error.message ? err.error.message : defaultMessage;
          this.isSubmitting = false;

        });
      }
    } catch (e) {
      this.errorMessage = 'Что-то пошло не так. Попробуйте еще раз или свяжитесь с администратором.';
      this.isSubmitting = false;
    }
  }
}
